import { GECKO_CONSTS } from '../../';

class GeckoSoundAlert {
  audio = new Audio();

  play(sound) {
    this.audio.src = sound;
    this.audio.play();
  }

  send = () => {
    this.play(GECKO_CONSTS.SOUND_STYLES[GECKO_CONSTS.SOUND_TYPE_SEND]);
  };

  receive = () => {
    this.play(GECKO_CONSTS.SOUND_STYLES[GECKO_CONSTS.SOUND_TYPE_RECEIVE]);
  };

  newConvo = () => {
    this.play(GECKO_CONSTS.SOUND_STYLES[GECKO_CONSTS.SOUND_TYPE_NEW_CONVO]);
  };
}

export default GeckoSoundAlert;
